import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams, useRouteMatch } from 'react-router-dom'

import { actions, selectors } from '../../redux'
import { resources } from '../../i18n'
import { router, routesPath } from '../../router'
import { Screen } from '../../types/global'

import { HeaderProps } from '.'

export const useHeaderProps = (): HeaderProps => {
  const dispatch = useDispatch()

  const routerParams = useParams<{ locale: string }>()

  const history = useHistory()
  const match = useRouteMatch()

  const isConnected = useSelector(selectors.auth.isConnected)

  return useMemo(
    () => ({
      languageSelect: {
        name: 'language',
        value: routerParams.locale,
        options: Object.keys(resources).map((locale) => ({
          label: resources[locale as keyof typeof resources]?.translation?.locale || locale,
          value: locale,
        })),
        onChange: (e) => {
          history.push(router(match.path, { locale: e.target.value }))
        },
      },
      onLogoClick: () => {
        if (isConnected) {
          dispatch(actions.app.setScreen({ screen: Screen.appointement }))
        } else {
          history.push(router(routesPath.root, { locale: routerParams.locale }))
        }
      },
    }),
    [dispatch, history, isConnected, match.path, routerParams.locale]
  )
}
